module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("For Olivia and Sophia:")])]), _vm._v(" You are both my sweet inspiration; every day with the two of you is filled with buttercream and chocolate sprinkles and joy.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("For Jim:")])]), _vm._v(" You make me laugh just as hard today as you did the day I met you— thank you for showing me that with a sense of humor, even life’s little catastrophes can be crafted into a delicious story.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("And in memory of my father,")])]), _vm._v(" who taught me that the sweetest recipe for a life well-lived starts with love.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23768659","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03dedication.vue
// module id = 63
// module chunks = 0